<template>
<el-row>
    <el-col :span="12" :xs="24">
    <el-row class="grid-content">
        <el-col>
            <div><span>课程：</span><span>{{course.CourseName}}</span></div>
        </el-col>
    </el-row>
    <el-row class="grid-content" v-if="usage !== 'studentVocationalTraining'">
        <el-col>
            <div><span>速成老师：</span><span>{{course.TeacherName}}</span></div>
        </el-col>
    </el-row>
    <el-row class="grid-content" v-if="usage == 'studentVocationalTraining'">
        <el-col>
            <div><span>类型：</span><span>{{course.CourseCategory}}</span></div>
        </el-col>
    </el-row>
    <el-row class="grid-content">
        <el-col>
            <div><span>状态：</span><span :class="course.IsActive?'color-active':'color-close'">{{course.IsActive?"已激活":"关闭"}}</span></div>
        </el-col>
    </el-row>
    <el-row class="grid-content">
        <el-table ref="signDetailsTable" v-loading="loading" :data="signDetails">
            <el-table-column prop="ActiveTimeText" label="签到日期"></el-table-column>
            <el-table-column prop="SignInTimeText" label="签到时间">
                <template slot-scope="scope"> 
                    <span v-if="scope.row.SignInTypeText != '' && scope.row.SignInTypeText != '正常'" class="make-sign-late">{{scope.row.SignInTypeText}}</span>  
                    <span v-if="scope.row.SignInTypeText == '正常'" >{{scope.row.SignInTimeText}}</span>
                    <span v-if="scope.row.SignInTypeText == '' "><i class="el-icon-minus icon-not-sign-color make-sign-late"></i></span>
                </template>
            </el-table-column>
            <el-table-column prop="LateMinuteText" class="red-color" label="缺时">
                <template slot-scope="scope">
                    <span :class="scope.row.LateMinuteText != '-'?'make-sign-late':''">{{scope.row.LateMinuteText}}</span> 
                </template>
            </el-table-column>
        </el-table>
    </el-row>
    </el-col>
</el-row>
</template> 

<script>
export default {
    data() {
        return {
            loading: false
        }
    },
    props: ["course", "signDetails", "usage"]
}
</script>



// WEBPACK FOOTER //
// src/components/studentSignDetail.vue